"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMDPPInsuranceSelected = exports.isWearableEAPFlow = exports.isBMWFlow = exports.isAppleDevice = exports.unauthenticatedAccess = exports.getIXPFlagValue = exports.getIXPValue = exports.getPlanInfo = exports.getSdpData = exports.hideCapacityLink = exports.displayLineItemPrice = exports.getDueTodayMonthlyLabel = exports.displayPlanDetailsinModal = exports.getLegalData = exports.includeTaxLabel = exports.servicePeriodLabel = exports.getLegalInfo = exports.showEarlyUpgradeLineItem = exports.populateZipEditdetailsForCommonCart = exports.populateZipEditdetails = exports.getDeviceHeader = exports.isAppleWatchFlow = exports.getDueMonthlyLabel = exports.getOneTimeCreditSubLabel = exports.getDueOneTimeLabel = exports.getCommonCartLegalLabel = exports.getLineItemName = exports.getChannelType = exports.getAccEditUrl = exports.isEnableValidateInventory = exports.GET_ICON_SVG = exports.isOrchestrationAddToCart = exports.isCommonCartPresent = exports.isUPOrAALFlow = exports.checkQueryParameter = exports.isExpressUpgradeViewEnabled = exports.isMyATTApp = exports.getMigrationSource = exports.getCookie = exports.getPriceBarData = exports.getPriceDataForPrepaidFlow = exports.getauthenticatedPersistantLoginURL = exports.enableCartCamapaignId = exports.isLoginRequiredonCart = exports.isNewWirelessFlow = exports.isAALFlow = exports.onCartRemoveLob = exports.getEditLinkUrl = exports.getProductSKUs = exports.getLOSGItems = exports.getLOSGItem = exports.utilCheckCMSContent = exports.isBundleinCart = exports.cmsDynamicContent = exports.amountWithDecimal = exports.getCampaignSessionId = exports.getInitialHeaders = exports.removeSpecialChars = exports.formatPhoneNumberWithDot = exports.getCurrentLOBList = exports.getCurrentLOB = exports.isPrepaidFlowType = exports.getCurrentFlowType = exports.getOrderSubType = exports.IsBroadbandInCart = exports.IsAccessoryInLosg = exports.IsAccessoryInCart = exports.IsAccessoryOnlyInCart = exports.IsSONOSAccessoryInCart = exports.isAuthuser = exports.enableHylatradeinComponent = exports.IsNMDPRFlow = exports.IsWirelessInCart = exports.IsBsseFlow = exports.isThisLOBInMetaData = exports.getLobList = exports.getCartStatus = exports.getCartResp = exports.rejectHTTPErrors = exports.isMobile = exports.DIGITAL_LOB_LIST = exports.WIRELESS_LOB_LIST = exports.HISA_LOB_LIST = exports.PANEL_STATUS = exports.LOBNames = void 0;
var StateProvider_1 = require("../api/StateProvider");
var localdatastore_1 = require("../config/localdatastore");
var CartHelperFunctions_1 = require("./CartHelperFunctions");
var CartUtilFunctions_1 = require("./CartUtilFunctions");
var CartUtil = require("../utils/CartUtilFunctions");
var wlsUtils = require("../utils/WirelessUtilFunctions");
var FeatureService_1 = require("../api/FeatureService");
var ReportingService_1 = require("../api/ReportingService");
var NON_DESKTOP_BREAKPOINT = 1024;
var phoneRegex = new RegExp('^[0-9() ]*$');
var headers = [
    {
        name: 'Accept',
        value: 'application/json,*/*',
    },
];
var LOBNames;
(function (LOBNames) {
    LOBNames["LOB_WIRELESS"] = "WIRELESS";
    LOBNames["LOB_DTVS"] = "DTVS";
    LOBNames["LOB_PREPAID"] = "PREPAID";
    LOBNames["LOB_DTV_NOW"] = "DTVNOW";
    LOBNames["LOB_BROADBAND"] = "BROADBAND";
    LOBNames["LOB_IPTV"] = "IPTV";
    LOBNames["LOB_ACCESSORY"] = "ACCESSORY";
    LOBNames["LOB_HBOMAX"] = "HBOMAX";
    LOBNames["LOB_VOIP"] = "VOIP";
    LOBNames["LOB_BUSINESSAPPS"] = "BUSINESSAPPS";
})(LOBNames = exports.LOBNames || (exports.LOBNames = {}));
var PANEL_STATUS;
(function (PANEL_STATUS) {
    PANEL_STATUS["REQUEST_INITIATED"] = "REQUEST_INITIATED";
    PANEL_STATUS["RESPONSE_RECEIVED"] = "RESPONSE_RECEIVED";
    PANEL_STATUS["NO_STATUS"] = "NO_STATUS";
})(PANEL_STATUS = exports.PANEL_STATUS || (exports.PANEL_STATUS = {}));
exports.HISA_LOB_LIST = "|" + LOBNames.LOB_DTVS + "|" + LOBNames.LOB_BROADBAND + "|" + LOBNames.LOB_IPTV + "|";
exports.WIRELESS_LOB_LIST = "|" + LOBNames.LOB_WIRELESS + "|" + LOBNames.LOB_PREPAID + "|" + LOBNames.LOB_ACCESSORY + "|";
exports.DIGITAL_LOB_LIST = "|" + LOBNames.LOB_DTV_NOW + "|";
exports.isMobile = function () {
    return (window.innerWidth <= NON_DESKTOP_BREAKPOINT);
};
function rejectHTTPErrors(res) {
    return (res.status >= 400) ? res.json().then(Promise.reject.bind(Promise)) : Promise.resolve(res);
}
exports.rejectHTTPErrors = rejectHTTPErrors;
function getCartResp() {
    var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'cartResponse');
    if (cartResponse && cartResponse.content && cartResponse.content.payload) {
        return cartResponse.content.payload;
    }
    else {
        return null;
    }
}
exports.getCartResp = getCartResp;
function getCartStatus() {
    var _a;
    var payload = getCartResp();
    return (payload === null || payload === void 0 ? void 0 : payload.cartStatus) ? payload === null || payload === void 0 ? void 0 : payload.cartStatus : ((payload === null || payload === void 0 ? void 0 : payload.commonCart) ? (_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.cartStatus : undefined);
}
exports.getCartStatus = getCartStatus;
function getLobList() {
    var _a, _b;
    var lobList = [];
    var payload = getCartResp();
    if (payload && payload.commonCart && payload.commonCart.losgs) {
        Object.values(payload.commonCart.losgs).forEach(function (value) {
            return lobList.push(value.productCategory);
        });
    }
    else {
        lobList = (((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lobList) ? payload.metadata.metadata.lobList : []);
    }
    return lobList;
}
exports.getLobList = getLobList;
function isThisLOBInMetaData(lobName) {
    var lobList = getLobList();
    return !!(lobList && lobList.indexOf(lobName) !== -1);
}
exports.isThisLOBInMetaData = isThisLOBInMetaData;
function IsBsseFlow() {
    var _a;
    var flowType = false;
    var payload = getCartResp();
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        flowType = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.billingSystemId === 'R';
        }).length > 0;
    }
    return flowType;
}
exports.IsBsseFlow = IsBsseFlow;
function IsWirelessInCart(cartpayload) {
    var _a, _b;
    var exist = false;
    var payload = cartpayload ? cartpayload : getCartResp();
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        exist = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.productCategory === LOBNames.LOB_WIRELESS;
        }).length > 0;
    }
    else if ((_b = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs) {
        exist = Object.values(payload.wirelessCart.losgs).filter(function (value) {
            return value.losgType === 'NEW' || value.losgType === 'UP' || value.losgType === 'AAL' ||
                value.losgType === 'AL' || value.losgType === 'EAAL' || value.losgType === 'PARK';
        }).length > 0;
    }
    else {
        exist = !!(isThisLOBInMetaData(LOBNames.LOB_WIRELESS)
            && payload.wirelessCart);
    }
    return exist;
}
exports.IsWirelessInCart = IsWirelessInCart;
function IsNMDPRFlow() {
    return true;
}
exports.IsNMDPRFlow = IsNMDPRFlow;
function enableHylatradeinComponent() {
    var payload = getCartResp();
    return !!(payload
        && payload.wirelessCart && (payload === null || payload === void 0 ? void 0 : payload.enableDisplayHylaSharedComponent));
}
exports.enableHylatradeinComponent = enableHylatradeinComponent;
function isAuthuser() {
    var payload = getCartResp();
    return !!(payload && payload.authUser);
}
exports.isAuthuser = isAuthuser;
function IsSONOSAccessoryInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(LOBNames.LOB_ACCESSORY)
        && payload.accessoryCart);
}
exports.IsSONOSAccessoryInCart = IsSONOSAccessoryInCart;
function IsAccessoryOnlyInCart() {
    var _a, _b, _c, _d;
    var isNonAccessoryInCart = false;
    var isAccessoryInCart = false;
    var payload = getCartResp();
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        isAccessoryInCart = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.productCategory === LOBNames.LOB_ACCESSORY;
        }).length > 0;
    }
    else {
        var losgs = ((_d = (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.wirelessMetadata) === null || _d === void 0 ? void 0 : _d.losgs);
        var losgList = losgs && Object.values(losgs);
        if ((losgList === null || losgList === void 0 ? void 0 : losgList.length) > 0) {
            losgList.forEach(function (losg) {
                var itemList = (losg === null || losg === void 0 ? void 0 : losg.lineItems) && Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
                if ((itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0) {
                    itemList.forEach(function (item) {
                        var _a;
                        if (((_a = item === null || item === void 0 ? void 0 : item.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'accessory') {
                            isAccessoryInCart = true;
                        }
                        else {
                            isNonAccessoryInCart = true;
                        }
                    });
                }
            });
        }
    }
    if (isAccessoryInCart && !isNonAccessoryInCart) {
        return true;
    }
    return false;
}
exports.IsAccessoryOnlyInCart = IsAccessoryOnlyInCart;
function IsAccessoryInCart() {
    var _a, _b, _c, _d;
    var isAccessoryInCart = false;
    var payload = getCartResp();
    if ((_a = payload === null || payload === void 0 ? void 0 : payload.commonCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        isAccessoryInCart = Object.values(payload.commonCart.losgs).filter(function (value) {
            return value.productCategory === LOBNames.LOB_ACCESSORY;
        }).length > 0;
    }
    else {
        var losgs = ((_d = (_c = (_b = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.wirelessMetadata) === null || _d === void 0 ? void 0 : _d.losgs);
        var losgList = losgs && Object.values(losgs);
        if ((losgList === null || losgList === void 0 ? void 0 : losgList.length) > 0) {
            losgList.forEach(function (losg) {
                var itemList = (losg === null || losg === void 0 ? void 0 : losg.lineItems) && Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
                if ((itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0) {
                    itemList.forEach(function (item) {
                        var _a;
                        if (((_a = item === null || item === void 0 ? void 0 : item.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'accessory') {
                            isAccessoryInCart = true;
                        }
                    });
                }
            });
        }
    }
    return isAccessoryInCart;
}
exports.IsAccessoryInCart = IsAccessoryInCart;
function IsAccessoryInLosg(losg) {
    var isAccessoryInLosg = false;
    var itemList = (losg === null || losg === void 0 ? void 0 : losg.lineItems) && Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
    if ((itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0) {
        itemList.forEach(function (item) {
            var _a;
            if (((_a = item === null || item === void 0 ? void 0 : item.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'accessory') {
                isAccessoryInLosg = true;
            }
        });
    }
    return isAccessoryInLosg;
}
exports.IsAccessoryInLosg = IsAccessoryInLosg;
function IsBroadbandInCart() {
    var payload = getCartResp();
    return !!(isThisLOBInMetaData(LOBNames.LOB_BROADBAND)
        && payload.broadbandCart);
}
exports.IsBroadbandInCart = IsBroadbandInCart;
function getOrderSubType(losgType) {
    var payload = getCartResp();
    var flowType;
    if (payload && payload.commonCart) {
        var losgTypeFound_1;
        Object.values(payload.commonCart.losgs).forEach(function (value) {
            if (losgType && losgType === value.losgType) {
                flowType = value.losgType + '_' + value.productCategory;
                losgTypeFound_1 = flowType;
            }
            else {
                flowType = (value.losgType === 'PRICE_CHANGE') ? flowType : value.losgType + '_' + value.productCategory;
            }
        });
        flowType = losgTypeFound_1 || flowType;
    }
    else {
        flowType = (payload &&
            payload.metadata && payload.metadata.metadata
            && payload.metadata.metadata.orderSubType);
    }
    return flowType;
}
exports.getOrderSubType = getOrderSubType;
function getCurrentFlowType() {
    var payload = getCartResp();
    if (payload &&
        payload.metadata && payload.metadata.metadata &&
        payload.metadata.metadata.wirelessMetadata &&
        payload.metadata.metadata.wirelessMetadata.paymentType) {
        return payload.metadata.metadata.wirelessMetadata.paymentType;
    }
    return getOrderSubType();
}
exports.getCurrentFlowType = getCurrentFlowType;
function isPrepaidFlowType() {
    var wirelessDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('APPSHELL'), 'wirelessDetails');
    if (wirelessDetails && wirelessDetails.wirelessType) {
        return wirelessDetails.wirelessType.toUpperCase() === CartHelperFunctions_1.FlowType.WIRELESS_PREPAID;
    }
    return false;
}
exports.isPrepaidFlowType = isPrepaidFlowType;
function getCurrentLOB() {
    var lobList = getLobList();
    return (lobList && lobList.length > 0) ? lobList[0] : null;
}
exports.getCurrentLOB = getCurrentLOB;
function getCurrentLOBList() {
    return getLobList();
}
exports.getCurrentLOBList = getCurrentLOBList;
function formatPhoneNumberWithDot(value, dotFormat) {
    var tempNumber;
    if (value && value.length > 0 && phoneRegex.test(value)) {
        tempNumber = value.replace(/[^0-9]/g, '');
    }
    else {
        return value;
    }
    if (tempNumber && tempNumber.length > 3 && tempNumber.length < 7) {
        return tempNumber.replace(/(\d{3})(\d*)/, '(' + '$1' + ') ' + '$2');
    }
    else if (tempNumber && tempNumber.length > 6 && tempNumber.length < 11) {
        if (dotFormat) {
            return tempNumber.replace(/(\d{3})(\d{3})(\d*)/, '' + '$1' + '.' + '$2' + '.' + '$3');
        }
        else {
            return tempNumber.replace(/(\d{3})(\d{3})(\d*)/, '(' + '$1' + ') ' + '$2' + '-' + '$3');
        }
    }
    else {
        return value;
    }
}
exports.formatPhoneNumberWithDot = formatPhoneNumberWithDot;
function removeSpecialChars(value) {
    if (value) {
        return value.replace(/[^a-zA-Z0-9]/g, '');
    }
    else {
        return value;
    }
}
exports.removeSpecialChars = removeSpecialChars;
function getInitialHeaders() {
    var defaultHeaders = new Headers();
    headers.forEach(function (header) {
        defaultHeaders.append(header.name, header.value);
    });
    if (getCurrentFlowType()) {
        defaultHeaders.append('idp-source', getCurrentFlowType());
    }
    if (isMyATTApp()) {
        defaultHeaders.append('idp-device-source', 'myATTApp');
    }
    var stateCsrfToken = StateProvider_1.StateProvider.getStateManagerInstance().get('appShell', 'csrf-token');
    if (stateCsrfToken && stateCsrfToken.value) {
        defaultHeaders.append('X-CSRF-TOKEN', stateCsrfToken.value);
    }
    var campaignId = StateProvider_1.StateProvider.getStateManagerInstance().get('appShell', 'campaignId');
    if (campaignId && campaignId.value) {
        defaultHeaders.append('idp-campaign-id', campaignId.value);
    }
    return defaultHeaders;
}
exports.getInitialHeaders = getInitialHeaders;
function getCampaignSessionId() {
    var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
    var campaignId = stateManager.get('appShell', 'campaignId');
    return campaignId && campaignId.value;
}
exports.getCampaignSessionId = getCampaignSessionId;
function amountWithDecimal(priceVal, decimalPointsUpto, currency) {
    var decimalPoints = decimalPointsUpto || 0;
    var amount;
    if (typeof priceVal === 'string') {
        amount = parseFloat(priceVal);
    }
    else {
        amount = priceVal;
    }
    amount = currency ? "" + currency + amount.toFixed(decimalPoints) : amount.toFixed(decimalPoints);
    return amount;
}
exports.amountWithDecimal = amountWithDecimal;
function cmsDynamicContent(content, txtArry) {
    var text = content || '';
    if (text && txtArry && txtArry.length > 0) {
        txtArry.forEach(function (obj) {
            var valtoreplace = String('{' + obj.replacewith + '}');
            text = text.replace(valtoreplace, String(obj.textVal));
        });
    }
    return text;
}
exports.cmsDynamicContent = cmsDynamicContent;
function isBundleinCart() {
    var lobList = getCurrentLOBList();
    var bundleValue = {
        isBBAndBusiness: false,
        isBBAndVOIP: false,
        isBundle: false,
        isBundleWithoutAccessory: false,
        isBundleWithoutDTVNorAccessory: false,
    };
    if (lobList && lobList.length > 2) {
        bundleValue.isBundle = true;
        bundleValue.isBundleWithoutAccessory = true;
        bundleValue.isBundleWithoutDTVNorAccessory = true;
        if (lobList.indexOf(LOBNames.LOB_DTV_NOW) > -1) {
            bundleValue.isBundleWithoutDTVNorAccessory = false;
        }
        if (lobList.indexOf(LOBNames.LOB_BUSINESSAPPS) > -1 && lobList.indexOf(LOBNames.LOB_BROADBAND) > -1) {
            bundleValue.isBBAndBusiness = true;
        }
    }
    else if (lobList && lobList.length === 2 && lobList.includes('HBOMAX')) {
        bundleValue.isBundleWithoutAccessory = false;
    }
    else if (lobList && lobList.length > 1) {
        bundleValue.isBundle = true;
        bundleValue.isBundleWithoutAccessory = true;
        bundleValue.isBundleWithoutDTVNorAccessory = true;
        if (lobList.indexOf(LOBNames.LOB_VOIP) > -1 && lobList.indexOf(LOBNames.LOB_BROADBAND) > -1) {
            bundleValue.isBBAndVOIP = true;
        }
        if (lobList.indexOf(LOBNames.LOB_BUSINESSAPPS) > -1 && lobList.indexOf(LOBNames.LOB_BROADBAND) > -1) {
            bundleValue.isBBAndBusiness = true;
        }
        if (lobList.indexOf(LOBNames.LOB_ACCESSORY) > -1) {
            bundleValue.isBundleWithoutAccessory = false;
            bundleValue.isBundleWithoutDTVNorAccessory = false;
        }
        if (lobList.indexOf(LOBNames.LOB_DTV_NOW) > -1) {
            bundleValue.isBundleWithoutDTVNorAccessory = false;
        }
    }
    return bundleValue;
}
exports.isBundleinCart = isBundleinCart;
// tslint:disable-next-line:no-any
function utilCheckCMSContent(cmsObj, cmskey) {
    if (cmsObj[cmskey] && cmskey) {
        return cmsObj[cmskey];
    }
    else {
        return ' # ' + cmskey + ' CMS key missing #';
    }
}
exports.utilCheckCMSContent = utilCheckCMSContent;
function getLOSGItem(billCode) {
    var temp = getLOSGItems(billCode);
    if (temp && temp.length > 0) {
        return temp[0];
    }
    return null;
}
exports.getLOSGItem = getLOSGItem;
function getLOSGItems(billCode) {
    var payload = getCartResp();
    if (payload &&
        payload.wirelessCart && payload.wirelessCart.losgs) {
        var logsList = payload.wirelessCart.losgs;
        var temp = Object.values(logsList).filter(function (losgItem) {
            return Object.values(losgItem.lineItems).filter(function (lineItem) {
                return lineItem.billingCode && lineItem.billingCode === billCode;
            }).length > 0;
        });
        if (temp && temp.length > 0) {
            return temp;
        }
    }
    return null;
}
exports.getLOSGItems = getLOSGItems;
function getProductSKUs(cartpayload) {
    var deviceRequest = wlsUtils.buildDeviceArray(cartpayload);
    var productSkus = Object.values(deviceRequest).map(function (item) { return item.skuId; });
    return productSkus;
}
exports.getProductSKUs = getProductSKUs;
function getEditLinkUrl(editLinkUrl) {
    var editLink = editLinkUrl;
    if (editLinkUrl && (/buy/i).test(editLinkUrl)) {
        var linkUrl = editLinkUrl.split('buy');
        editLink = linkUrl[1];
    }
    return editLink;
}
exports.getEditLinkUrl = getEditLinkUrl;
function onCartRemoveLob(isEmptyCart) {
    var checkIsBundle = isBundleinCart().isBundleWithoutAccessory;
    if (isEmptyCart && !checkIsBundle) {
        // this code is to notify app shell that cart is empty
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        stateManager.set('emptyCart', { emptyCart: true });
        stateManager.set('priceBarUpdate', {
            dueMonthly: 0,
            dueOneTime: 0,
            dueToday: 0,
            readyToCheckout: false,
        });
        stateManager.set('CurrentPageURL', { name: ReportingService_1.PageUrls.CART });
    }
    else {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
        stateManager.set('cartUpdate', { cartRefresh: true });
    }
}
exports.onCartRemoveLob = onCartRemoveLob;
function isAALFlow() {
    var orderSubType = getOrderSubType('AL'); // AL is passed for BSSE flow only
    var lobList = getLobList();
    return !!(lobList.indexOf(LOBNames.LOB_WIRELESS) > -1
        && orderSubType && ((orderSubType.toUpperCase().indexOf('AAL_WIRELESS') > -1) ||
        (orderSubType.toUpperCase().indexOf('AL_WIRELESS') > -1)));
}
exports.isAALFlow = isAALFlow;
function isNewWirelessFlow() {
    var orderSubType = getOrderSubType();
    var lobList = getLobList();
    return !!(lobList.indexOf(LOBNames.LOB_WIRELESS) > -1 && orderSubType &&
        ((orderSubType.toUpperCase().indexOf('NEW_WIRELESS') > -1)));
}
exports.isNewWirelessFlow = isNewWirelessFlow;
function isLoginRequiredonCart() {
    var payload = getCartResp();
    if (payload) {
        return !!payload.requiredLogin;
    }
    return false;
}
exports.isLoginRequiredonCart = isLoginRequiredonCart;
function enableCartCamapaignId(cartpayload) {
    var payload = cartpayload ? cartpayload : getCartResp();
    return !!(payload && payload.enableCartCampaignId);
}
exports.enableCartCamapaignId = enableCartCamapaignId;
function getauthenticatedPersistantLoginURL(skipCartRedirection) {
    var loginredirectionURL = '/buy/postpaid/?wlsfi=';
    var orderSubType = getOrderSubType();
    if (orderSubType) {
        if (orderSubType === 'AAL_WIRELESS') {
            loginredirectionURL = loginredirectionURL + 'AL';
        }
        if (orderSubType === 'UPGRADE_WIRELESS' ||
            orderSubType === 'UP_AL_WIRELESS') {
            loginredirectionURL = loginredirectionURL + 'UP';
        }
    }
    if (!skipCartRedirection) {
        loginredirectionURL = loginredirectionURL + '&redirectTo=CART';
    }
    return loginredirectionURL;
}
exports.getauthenticatedPersistantLoginURL = getauthenticatedPersistantLoginURL;
function getPriceDataForPrepaidFlow(payload, priceBarData) {
    var stickyCartFeatureFlag;
    if (payload && payload.enableStickyCartCharges) {
        stickyCartFeatureFlag = payload.enableStickyCartCharges;
        // Double equals is added intentionally. Do not change.
        if (stickyCartFeatureFlag && priceBarData && Number(priceBarData.dueMonthly) === 0) {
            delete priceBarData.dueMonthly;
        }
        if (stickyCartFeatureFlag && priceBarData && Number(priceBarData.dueOneTime) === 0) {
            delete priceBarData.dueOneTime;
        }
    }
    return priceBarData;
}
exports.getPriceDataForPrepaidFlow = getPriceDataForPrepaidFlow;
function getPriceBarData(payload) {
    var priceBarUpdate;
    if (isPrepaidFlowType()) {
        var cartState = getPriceDataForPrepaidFlow(payload, payload.orderPriceInfo);
        priceBarUpdate = {
            dueMonthly: cartState.dueMonthly,
            dueOneTime: cartState.dueOneTime,
            dueToday: cartState.dueToday,
            isAmtProvidedTaxInclusive: cartState.taxCalculated,
            readyToCheckout: payload.cartStatus.readyToCheckout,
        };
    }
    else {
        var cartStatus = getCartStatus();
        priceBarUpdate = {
            dueMonthly: payload.orderPriceInfo.dueMonthly,
            dueOneTime: payload.orderPriceInfo.dueOneTime,
            dueToday: payload.orderPriceInfo.dueToday,
            isAmtProvidedTaxInclusive: payload.orderPriceInfo.taxCalculated,
            readyToCheckout: cartStatus.readyToCheckout,
        };
    }
    return priceBarUpdate;
}
exports.getPriceBarData = getPriceBarData;
function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    var cookieName = '';
    ca.forEach(function (val) {
        var c = val;
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            cookieName = c.substring(name.length, c.length);
        }
    });
    return cookieName;
}
exports.getCookie = getCookie;
function getMigrationSource() {
    var payload = getCartResp();
    var migrationSource = '';
    if (payload && payload.metadata &&
        payload.metadata.metadata && payload.metadata.metadata.iptvMetadata &&
        payload.metadata.metadata.iptvMetadata.losgs) {
        var iptvMetadataLog_1 = Object.values(payload.metadata.metadata.iptvMetadata.losgs);
        iptvMetadataLog_1.forEach(function (item, index) {
            if (iptvMetadataLog_1[index] && iptvMetadataLog_1[index].migrationSource) {
                migrationSource = iptvMetadataLog_1[index].migrationSource;
            }
        });
    }
    return migrationSource;
}
exports.getMigrationSource = getMigrationSource;
function isMyATTApp() {
    var cookieVal = getCookie('accessDomain');
    if (cookieVal && cookieVal.toLowerCase() === 'native') {
        return true;
    }
    else {
        return false;
    }
    /* old code CDEX-257681
    // tslint:disable-next-line:no-any
    const webkit: any = window.webkit;
    const isMyAttApp = (typeof webkit !== 'undefined' && webkit != null) &&
      (typeof webkit.messageHandlers !== 'undefined' && webkit.messageHandlers != null);
    return isMyAttApp;
    */
}
exports.isMyATTApp = isMyATTApp;
function isExpressUpgradeViewEnabled() {
    var payload = getCartResp();
    return (payload && payload.enableExpupgradeView);
}
exports.isExpressUpgradeViewEnabled = isExpressUpgradeViewEnabled;
function checkQueryParameter(queryParam) {
    var url = location.href.toLowerCase();
    var queryParams = url.split('?')[1];
    var isQueryParameters = false;
    if (queryParams && queryParam) {
        var parmArry = queryParams.split('&');
        if (parmArry && parmArry.indexOf(queryParam.toLowerCase()) > -1) {
            isQueryParameters = true;
        }
    }
    return isQueryParameters;
}
exports.checkQueryParameter = checkQueryParameter;
function isUPOrAALFlow() {
    return (getCurrentFlowType() === CartHelperFunctions_1.FlowType.UPGRADE_WIRELESS || getCurrentFlowType() === CartHelperFunctions_1.FlowType.UP_AL_WIRELESS ||
        getCurrentFlowType() === CartHelperFunctions_1.FlowType.AAL_WIRELESS);
}
exports.isUPOrAALFlow = isUPOrAALFlow;
function isCommonCartPresent(payloadContent) {
    var payload = payloadContent || getCartResp();
    return (payload && payload.commonCart) ? true : false;
}
exports.isCommonCartPresent = isCommonCartPresent;
function isOrchestrationAddToCart() {
    var payload = getCartResp();
    return (payload && payload.enableOrchestrationLayerAddToCart) ? true : false;
}
exports.isOrchestrationAddToCart = isOrchestrationAddToCart;
var GET_ICON_SVG;
(function (GET_ICON_SVG) {
    GET_ICON_SVG["PEN"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><path fill=\"#000000\" d=\"M23.1 8.2l5.6 5.6-13.3 13.3s-.1 0-.1.1c-.3.3-.7.5-1 .7l-7.7 3.2c-.4.2-.9-.3-.7-.7l3.2-7.7c.1-.3.4-.7.6-1l.1-.1L23.1 8.2zm8.1-.8l-1.7-1.7c-1.1-1.1-2.8-1.1-3.8-.1l-1.5 1.5 5.6 5.6 1.5-1.5c1-1 .9-2.7-.1-3.8z\"/></svg>";
    GET_ICON_SVG["TRUCK"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-truck\" viewBox=\"0 0 16 16\"> <path d=\"M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z\"/> </svg>";
    GET_ICON_SVG["TRASH"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 72\"><path fill=\"#191919\" d=\"M57.168 17.76H43.226v-3.933a3 3 0 0 0-3-3h-8.4a3 3 0 0 0-3 3v3.932H14.832a.72.72 0 0 0-.72.72v2.56a.72.72 0 0 0 .72.72h3.113l1.017 35.413c0 3.305.62 4 4 4h26.04c3.498 0 4-.53 4-4l1.022-35.414h3.144a.72.72 0 0 0 .72-.72v-2.56a.72.72 0 0 0-.72-.72zm-25.955 32.7a2 2 0 0 1-4 0V28.785a2 2 0 0 1 4 0zm13.393 0a2 2 0 0 1-4 0V28.785a2 2 0 1 1 4 0z\"/></svg>";
    GET_ICON_SVG["UP"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><path d=\"M30.667 22.921a2.4 2.4 0 0 1-4.094 1.694l-8.564-8.577-8.581 8.602a2.398 2.398 0 1 1-3.395-3.387l9.596-9.62a3.37 3.37 0 0 1 2.376-.976 3.374 3.374 0 0 1 2.378.972l9.584 9.599c.467.467.7 1.08.7 1.693\" fill=\"#1d2329\"/></svg>";
    GET_ICON_SVG["DOWN"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><path d=\"M5.412 13.079a2.398 2.398 0 0 1 4.094-1.695l8.564 8.577 8.581-8.602a2.398 2.398 0 1 1 3.395 3.387l-9.596 9.62a3.365 3.365 0 0 1-2.376.976 3.374 3.374 0 0 1-2.378-.972l-9.584-9.599a2.375 2.375 0 0 1-.7-1.692\" fill=\"#1d2329\"/></svg>";
    GET_ICON_SVG["CHECK"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.33 26.75l-10-10 1.42-1.42 8.62 8.63 18-18 1.42 1.41z\"/></svg>";
    GET_ICON_SVG["QUESTION"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"svg-base\" d=\"M8.5 1A7.5 7.5 0 1016 8.5 7.5 7.5 0 008.5 1zM9 12H8v-1h1zm.83-3.55l-.1.08C9.16 9 9 9.13 9 9.68V10H8v-.32a2.21 2.21 0 011.1-1.93l.11-.08a1.11 1.11 0 00.54-.9c0-.69-.72-.76-1-.76a2.18 2.18 0 00-1.45.63l-.7-.74A3.14 3.14 0 018.72 5a1.8 1.8 0 012 1.76 2.11 2.11 0 01-.89 1.69z\"/></svg>";
    GET_ICON_SVG["HI"] = "<svg viewBox=\"0 0 40 42\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M34.4384615,0 L2.27692308,0 C0.996153846,0 0,1.14285714 0,2.28571429 L0,29.2857143 C0,30.5714286 0.996153846,31.5714286 2.27692308,31.5714286 L15.3692308,31.5714286 C16.5076923,31.7142857 17.5038462,31.8571429 18.6423077,33.2857143 L23.7653846,39.1428571 C23.7653846,39.1428571 24.4769231,40 25.3307692,40 C26.3269231,40 27.1807692,39.1428571 27.1807692,38.1428571 L27.1807692,33.1428571 C27.1807692,32 28.0346154,31.4285714 29.0307692,31.4285714 L34.7230769,31.4285714 C36.0038462,31.4285714 37,30.4285714 37,29.1428571 L37,2.28571429 C36.7153846,1.14285714 35.7192308,0 34.4384615,0 Z M20.9978223,25.3966603 L17.3719512,25.3966603 L17.3719512,17.4596524 C17.3719512,16.7247442 17.2269164,16.1368177 16.9368467,15.6958729 C16.646777,15.4019096 16.0666376,15.1079463 15.3414634,15.1079463 C14.4712544,15.1079463 13.7460801,15.4019096 12.8758711,16.1368177 L12.8758711,25.3966603 L9.25,25.3966603 L9.25,6.72999359 L12.8758711,6.72999359 L12.8758711,13.6381301 C13.4560105,13.0502036 14.1811847,12.6092587 14.761324,12.4622771 C15.3414634,12.1683138 16.0666376,12.0213322 16.7918118,12.0213322 C18.0971254,12.0213322 19.1123693,12.4622771 19.9825784,13.3441668 C20.7077526,14.2260566 21.1428571,15.5488912 21.1428571,17.1656891 L21.1428571,25.3966603 L20.9978223,25.3966603 Z M27.75,25.3966603 L23.7857143,25.3966603 L23.7857143,12.0633269 L27.5975275,12.0633269 L27.5975275,25.3966603 L27.75,25.3966603 Z M27.1836735,10.158565 C26.7589286,10.4442793 26.3341837,10.7299936 25.7678571,10.7299936 C25.2015306,10.7299936 24.6352041,10.5871364 24.3520408,10.158565 C23.9272959,9.87285073 23.7857143,9.30142216 23.7857143,8.72999359 C23.7857143,8.15856502 23.9272959,7.72999359 24.3520408,7.30142216 C24.7767857,7.01570788 25.2015306,6.72999359 25.7678571,6.72999359 C26.3341837,6.72999359 26.9005102,6.87285073 27.1836735,7.30142216 C27.6084184,7.58713645 27.75,8.15856502 27.75,8.72999359 C27.75,9.30142216 27.6084184,9.72999359 27.1836735,10.158565 Z\" id=\"hello\" fill=\"#FFFFFF\" fill-rule=\"nonzero\"></path></svg>";
    GET_ICON_SVG["TIMER"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M25.06 8.69l1.71-2-1.54-1.33-1.71 2.05A13 13 0 0017 5.05V3h2V1h-6v2h2v2.05a13 13 0 1010.06 3.64zM16 29a11 11 0 1111-11 11 11 0 01-11 11zm2-11a2 2 0 01-4 0 2.09 2.09 0 01.07-.51l-4.83-4.84 1.41-1.41 4.84 4.83A2.09 2.09 0 0116 16a2 2 0 012 2z\"/></svg>";
    GET_ICON_SVG["E_SIM"] = "<svg data-name=\"Icon (Outlined)\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"><path class=\"svg-base\" d=\"M76.38 24.87l-12.17-13A6 6 0 0059.83 10H24a6 6 0 00-6 6v64a6 6 0 006 6h48a6 6 0 006-6V29a6 6 0 00-1.62-4.13zM76 80a4 4 0 01-4 4H24a4 4 0 01-4-4V16a4 4 0 014-4h35.83a4 4 0 012.92 1.26l12.17 13A4 4 0 0176 29z\"/><path class=\"svg-accent\" d=\"M54 50H28v28h40V50zM40 76H30V63h10zm12 0H42V61H30v-9h22zm14 0H54v-8h12zm0-10H54V52h12zm-7.17-36.45a13.5 13.5 0 00-1.26-5.92A9.84 9.84 0 0054 19.51a10 10 0 00-5.5-1.5 10.38 10.38 0 00-5.62 1.6 11.42 11.42 0 00-4.12 4.58A14.48 14.48 0 0037.17 31a14.7 14.7 0 001.47 6.67 11.3 11.3 0 004.25 4.63 12.14 12.14 0 006.49 1.7 18.29 18.29 0 004.73-.55 15.15 15.15 0 004-1.82l-.88-1.84a15.51 15.51 0 01-3.68 1.57 16.59 16.59 0 01-4.22.46 9.55 9.55 0 01-4.82-1.23A9.3 9.3 0 0141.09 37a11.78 11.78 0 01-1.45-5.36h19.1q.09-1.02.09-2.09zm-2.47.09H39.69a12.51 12.51 0 011.4-4.82 9 9 0 013.08-3.39 8.14 8.14 0 018.39-.15 7.33 7.33 0 012.78 3.23 10.85 10.85 0 011 4.75z\"/></svg>";
    GET_ICON_SVG["P_SIM"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\"><path class=\"svg-base\" d=\"M72 86H24a6 6 0 01-6-6V16a6 6 0 016-6h35.83a6 6 0 014.38 1.9l12.17 13A6 6 0 0178 29v51a6 6 0 01-6 6zM24 12a4 4 0 00-4 4v64a4 4 0 004 4h48a4 4 0 004-4V29a4 4 0 00-1.08-2.74l-12.17-13A4 4 0 0059.83 12z\"/><path class=\"svg-accent\" d=\"M28 48v29h40V48zm38 17H54V50h12zM52 50v25H42V60H30V50zM30 62h10v13H30zm24 13v-8h12v8z\"/></svg>";
    GET_ICON_SVG["SMARTWATCH_64"] = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\"><path class=\"svg-base\" d=\"M49.27 10l-2.11-8H16.84l-2.11 8A5 5 0 0010 15v34a5 5 0 004.73 5l2.11 8h30.32l2.11-8A5 5 0 0054 49V15a5 5 0 00-4.73-5zM18.38 4h27.24l1.57 6H16.81zm27.24 56H18.38l-1.57-6h30.38zM52 49a3 3 0 01-3 3H15a3 3 0 01-3-3V15a3 3 0 013-3h34a3 3 0 013 3zM33 31.59l8 8L39.58 41 31 32.41V19h2z\"/></svg>";
})(GET_ICON_SVG = exports.GET_ICON_SVG || (exports.GET_ICON_SVG = {}));
function isEnableValidateInventory() {
    var payload = getCartResp();
    return !!(payload && payload.enableValidateInventory && !CartUtilFunctions_1.isIncompleteCart());
}
exports.isEnableValidateInventory = isEnableValidateInventory;
function getAccEditUrl() {
    var payload = getCartResp();
    return payload && payload.metadata && payload.metadata.metadata &&
        payload.metadata.metadata.wirelessMetadata &&
        payload.metadata.metadata.wirelessMetadata.editUrl;
}
exports.getAccEditUrl = getAccEditUrl;
function getChannelType(channeltype) {
    if (channeltype && channeltype.type && channeltype.type === 'native') {
        return CartUtil.CHANNEL_TYPE.CHANNEL_NATIVE;
    }
    else if (channeltype && channeltype.type && channeltype.type === 'email') {
        return CartUtil.CHANNEL_TYPE.CHANNEL_EMAIL;
    }
    else {
        return '';
    }
}
exports.getChannelType = getChannelType;
function getLineItemName(lineItem, hideLink, isCommonCart, isExpressUp, cartSummaryCMSData, cartData, unauthAccess) {
    if (lineItem && lineItem.fees && (lineItem.fees.feeId === 'ACT' || lineItem.fees.feeId === 'ACTIVATION_FEE')) {
        if (lineItem.fees.waivedIndicator) {
            var priceData = wlsUtils.getLineItemPriceData(lineItem, cartData.mixAndMatch, true);
            return 'Activation fee ($' + unauthAccess ? '' : priceData.lineItemPrice.price + ')';
        }
        else {
            return isCommonCart ?
                cartSummaryCMSData.bsseActivationFeeLabel : cartSummaryCMSData.activationFee;
        }
    }
    else if (lineItem && lineItem.fees && lineItem.fees.feeId === 'UPG') {
        if (lineItem.fees.waivedIndicator) {
            var priceData = wlsUtils.getLineItemPriceData(lineItem, cartData.mixAndMatch, true);
            return 'Upgrade fee ($' + unauthAccess ? '' : priceData.lineItemPrice.price + ')';
        }
        else {
            return 'Upgrade fee (due on 1st bill)';
        }
    }
    if (lineItem && lineItem.itemType &&
        lineItem.itemType.toUpperCase() === 'DOWNPAYMENT') {
        return cartSummaryCMSData.downPaymentLabel;
    }
    if (lineItem && lineItem.itemType &&
        lineItem.itemType.toUpperCase() === 'ADVANCEPAYMENT') {
        return cartSummaryCMSData.advancePaymentLabel;
    }
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'ACCESSORY') {
        var displayName = void 0;
        if (lineItem.quantity > 0 && !(isExpressUp && !hideLink)) {
            var priceAmt = unauthAccess ? ' ' : "($" + lineItem.price.baseAmount + "/ea.)";
            displayName = lineItem.displayName + " " + priceAmt;
        }
        else if (lineItem.quantity > 1) {
            var priceAmt = unauthAccess ? ' ' : lineItem.displayName + ' ' + '|' + ' ' + 'Qty:' + lineItem.quantity;
            displayName = priceAmt;
        }
        return (displayName) ? displayName : lineItem.displayName;
    }
    else {
        return lineItem ? lineItem.displayName : '';
    }
}
exports.getLineItemName = getLineItemName;
function getCommonCartLegalLabel(externalOrderSourceType, cartSummaryCMSData) {
    var flowType = getCurrentFlowType();
    if (externalOrderSourceType) {
        var legalText = cartSummaryCMSData.externalOrderSourceLegalLabel ||
            "*Plus add'l taxes and fees. Amounts shown are for this order only and don't include current account charges.";
        return legalText;
    }
    else if (flowType === 'AL_WIRELESS') {
        var legalText = cartSummaryCMSData.alCommonCartLegalLabel ||
            "*Includes estimated taxes and fees. Amounts shown are for this order only and don't include current account charges.";
        return legalText;
    }
    else {
        return cartSummaryCMSData.commonCartLegalLabel;
    }
}
exports.getCommonCartLegalLabel = getCommonCartLegalLabel;
function getDueOneTimeLabel(externalOrderSourceType, cartSummaryCMSData) {
    if (externalOrderSourceType) {
        return cartSummaryCMSData.expupDueOnFirstBillLabel;
    }
    else {
        return cartSummaryCMSData.bsseOneTimeLabel;
    }
}
exports.getDueOneTimeLabel = getDueOneTimeLabel;
function getOneTimeCreditSubLabel(accountInfo, losgs, cartSummaryCMSData) {
    if (accountInfo && accountInfo.billCycleStartDate && accountInfo.billCycleEndDate) {
        var creditLabel = cartSummaryCMSData.bsseCreditSubLabel ? cartSummaryCMSData.bsseCreditSubLabel :
            'Credit from {0} – {1}. Your monthly plan price for your existing lines will go down with today’s order';
        creditLabel = creditLabel.replace('{0}', accountInfo.billCycleStartDate)
            .replace('{1}', accountInfo.billCycleEndDate);
        return creditLabel;
    }
    else {
        return '';
    }
}
exports.getOneTimeCreditSubLabel = getOneTimeCreditSubLabel;
function getDueMonthlyLabel(isCommonCart, externalOrderSourceType, cartSummaryCMSData) {
    if (isCommonCart || externalOrderSourceType) {
        return cartSummaryCMSData.expupDueMonthlyLabel;
    }
    else {
        return cartSummaryCMSData.dueMonthlyLabel;
    }
}
exports.getDueMonthlyLabel = getDueMonthlyLabel;
function isAppleWatchFlow(losg) {
    var _a, _b, _c;
    var isAppleWatch = false;
    var payload = getCartResp();
    var orderSubType = getOrderSubType();
    var isActivationFlow = !!(orderSubType &&
        ((orderSubType.toUpperCase().indexOf('ACTIVATION') > -1)));
    if (losg) {
        (_a = Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems)) === null || _a === void 0 ? void 0 : _a.map(function (lineItem) {
            var _a, _b, _c, _d, _e, _f;
            if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE' && isActivationFlow) {
                isAppleWatch = ((_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _b === void 0 ? void 0 : _b.make) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'apple'
                    && ((_f = (_e = (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _d === void 0 ? void 0 : _d.wirelessHardGoodCharacteristics) === null || _e === void 0 ? void 0 : _e._deviceSubType) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === 'wearable';
            }
        });
    }
    else {
        (_c = Object.values((_b = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs)) === null || _c === void 0 ? void 0 : _c.map(function (losgData) {
            var _a;
            (_a = Object.values(losgData === null || losgData === void 0 ? void 0 : losgData.lineItems)) === null || _a === void 0 ? void 0 : _a.map(function (lineItem) {
                var _a, _b, _c, _d, _e, _f;
                if (((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE' && isActivationFlow) {
                    isAppleWatch = ((_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _b === void 0 ? void 0 : _b.make) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'apple'
                        && ((_f = (_e = (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _d === void 0 ? void 0 : _d.wirelessHardGoodCharacteristics) === null || _e === void 0 ? void 0 : _e._deviceSubType) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === 'wearable';
                }
            });
        });
    }
    return isAppleWatch;
}
exports.isAppleWatchFlow = isAppleWatchFlow;
function getDeviceHeader(lineNumber, losg, index, externalOrderSourceType, eapFlowContext, cartSummaryCMSData, payload, isAalFlow, isMixedCart, isCrpUpgrade) {
    var _a, _b, _c;
    var lineDisplayHeaderText = cartSummaryCMSData.lineLabel + " " + index;
    var isFirstNet = CartUtil.isFNIntentPresent(losg);
    lineDisplayHeaderText = isFirstNet ? cartSummaryCMSData.firstNetLine.toUpperCase() + " <b>" + lineDisplayHeaderText + "</b>"
        : lineDisplayHeaderText;
    if (losg && externalOrderSourceType === 'BMWSMART') {
        lineDisplayHeaderText = "NumberSync for Connected Car";
        return lineDisplayHeaderText;
    }
    if (losg && losg.subscriberName && losg.subscriberName.firstName) {
        var lineName = losg.subscriberName.firstName.toUpperCase();
        lineDisplayHeaderText = isFirstNet ?
            lineName + "'S " + cartSummaryCMSData.firstNetLine + " " + cartSummaryCMSData.lineLabel
            :
                wlsUtils.multiUpCheck() ? lineName + "'S upgrade " + lineNumber
                    : lineName + "'S " + cartSummaryCMSData.lineLabel;
        if (isCrpUpgrade && losg.losgType.toUpperCase() === 'CHANGE') {
            lineDisplayHeaderText = lineName + "'S " + cartSummaryCMSData.lineLabel + lineNumber;
        }
    }
    if (losg && losg.losgType && losg.losgType.toUpperCase() === 'UP' && lineNumber && !wlsUtils.multiUpCheck()) {
        if (losg.subscriberName && losg.subscriberName.firstName) {
            var lineName = losg.subscriberName.firstName.toUpperCase();
            lineDisplayHeaderText = isFirstNet ?
                lineName + "'S " + cartSummaryCMSData.firstNetLine + " " + cartSummaryCMSData.lineLabel + lineNumber
                : lineName + "'S " + cartSummaryCMSData.lineLabel + lineNumber;
            if (isCrpUpgrade) {
                lineDisplayHeaderText = lineName + "'S upgrade " + lineNumber;
            }
        }
        else if ((_a = payload.authDetails) === null || _a === void 0 ? void 0 : _a.firstName) {
            lineDisplayHeaderText = payload.authDetails.firstName + "'S UPGRADE " + lineDisplayHeaderText;
        }
        else {
            lineDisplayHeaderText = isFirstNet ?
                cartSummaryCMSData.firstNetLine + " " + cartSummaryCMSData.lineLabel + lineNumber :
                "" + cartSummaryCMSData.lineLabel + lineNumber;
        }
    }
    if (isAalFlow && !isMixedCart) {
        if (losg && losg.subscriberName && losg.subscriberName.firstName) {
            var lineName = losg.subscriberName.firstName.toUpperCase();
            lineDisplayHeaderText = isFirstNet ? lineName + "'S " + cartSummaryCMSData.firstNetLine + "\n               " + cartSummaryCMSData.lineLabel :
                lineName + "'S " + cartSummaryCMSData.lineLabel;
        }
        else {
            lineDisplayHeaderText = isFirstNet ? "NEW " + cartSummaryCMSData.firstNetLine.toUpperCase() + " LINE " + index
                : cartSummaryCMSData.lineAALLabel + " " + index;
        }
    }
    if (eapFlowContext.isEAPFlow) {
        if (eapFlowContext.simType === 'eSIM' || eapFlowContext.simType === 'pSIM') {
            lineDisplayHeaderText = cartSummaryCMSData.lineLabel + " " + index;
        }
        else if (isAppleWatchFlow(losg)) {
            lineDisplayHeaderText = cartSummaryCMSData.lineAALLabel + " " + index;
        }
        else {
            lineDisplayHeaderText = cartSummaryCMSData.lineEAPLabel;
        }
    }
    if (losg && losg.subscriberName && losg.subscriberName.firstName && CartUtil.isNewWirelessPostpaidView()) {
        var lineName = losg.subscriberName.firstName;
        var lineLabel = cartSummaryCMSData.lineLabel ?
            cartSummaryCMSData.lineLabel.toLowerCase() : '';
        lineDisplayHeaderText = isFirstNet ? lineName + "'s " + cartSummaryCMSData.firstNetLine + " " + lineLabel
            : lineName + "'s " + lineLabel;
    }
    if (wlsUtils.isSimSwap(losg) && ((_b = payload.authDetails) === null || _b === void 0 ? void 0 : _b.firstName)) {
        var lineName = (_c = payload.authDetails.firstName) === null || _c === void 0 ? void 0 : _c.toUpperCase();
        lineDisplayHeaderText = lineName + "'S " + cartSummaryCMSData.lineLabel + " " + lineNumber;
    }
    return lineDisplayHeaderText;
}
exports.getDeviceHeader = getDeviceHeader;
function populateZipEditdetails(cart, cartSummaryCMSData) {
    return ({
        displayTaxZip: !!cart.taxZipCode, isEditable: !!cart.isShoppingZipCode, zipCode: cart.taxZipCode,
        zipDisplayContent: cartSummaryCMSData.zipCodeEditLinkdescription ||
            'Includes estimated sales tax based on ZIP',
        zipErrorContent: cartSummaryCMSData.zipCodeFieldErrorMessage || 'ZIP Code is invalid',
        zipUpdateButtonContent: cartSummaryCMSData.zipCodeUpdateButtonLabel || 'Update',
    });
}
exports.populateZipEditdetails = populateZipEditdetails;
function populateZipEditdetailsForCommonCart(losgsData, cartSummaryCMSData) {
    var taxZipCode = '';
    losgsData.forEach(function (losg) { var _a; taxZipCode = (_a = losg === null || losg === void 0 ? void 0 : losg.losgTaxInfo) === null || _a === void 0 ? void 0 : _a.taxZipCode; });
    return ({
        displayTaxZip: !!taxZipCode,
        isEditable: isAALFlow() ? false : true,
        zipCode: taxZipCode,
        zipDisplayContent: cartSummaryCMSData.zipCodeDescriptionForCommonCart ||
            'Estimated taxes and fees based on ZIP',
        zipErrorContent: cartSummaryCMSData.zipCodeFieldErrorMessage || 'ZIP Code is invalid',
        zipUpdateButtonContent: cartSummaryCMSData.zipCodeUpdateButtonLabel || 'Update',
    });
}
exports.populateZipEditdetailsForCommonCart = populateZipEditdetailsForCommonCart;
function showEarlyUpgradeLineItem(itemType, earlyUpgradeAmount) {
    if ((itemType && itemType.toUpperCase() === 'PAYOFF' && earlyUpgradeAmount > 0)
        || (itemType && itemType.toUpperCase() === 'PAYUP' && earlyUpgradeAmount > 0)) {
        return false;
    }
    return true;
}
exports.showEarlyUpgradeLineItem = showEarlyUpgradeLineItem;
function getLegalInfo(cartSummaryCMSData, externalOrderSourceType) {
    var legalInfo = { dueFirstMonthLegal: {}, dueMonthlyLegal: {},
        dueTodayLegal: {}, govTaxLegal: {},
    };
    var dueTodayLegalContents = {
        legalModalPath: CartUtil.getLegalIDPUrl('onToday', cartSummaryCMSData).legalModalPath,
        legallinkText: CartUtil.getLegalIDPUrl('onToday', cartSummaryCMSData).legallinkText,
        shortText: CartUtil.getLegalIDPUrl('onToday', cartSummaryCMSData).shortText,
    };
    var dueMonthlyLegalContents = {
        legalModalPath: CartUtil.getLegalIDPUrl('onMonthly', cartSummaryCMSData).legalModalPath,
        legallinkText: CartUtil.getLegalIDPUrl('onMonthly', cartSummaryCMSData).legallinkText,
        shortText: CartUtil.getLegalIDPUrl('onMonthly', cartSummaryCMSData).shortText,
    };
    var dueFirstMonthLegalContents = {
        legalModalPath: CartUtil.getLegalIDPUrl('onFirstBill', cartSummaryCMSData, false, externalOrderSourceType).legalModalPath,
        legallinkText: CartUtil.getLegalIDPUrl('onFirstBill', cartSummaryCMSData, false, externalOrderSourceType).legallinkText,
        shortText: CartUtil.getLegalIDPUrl('onFirstBill', cartSummaryCMSData, false, externalOrderSourceType).shortText,
    };
    var govTaxAndFees = {
        legalModalPath: CartUtil.getLegalIDPUrl('attFees', cartSummaryCMSData).legalModalPath,
        legallinkText: CartUtil.getLegalIDPUrl('attFees', cartSummaryCMSData).legallinkText,
        shortText: CartUtil.getLegalIDPUrl('attFees', cartSummaryCMSData).shortText,
    };
    legalInfo.dueTodayLegal = dueTodayLegalContents;
    legalInfo.dueMonthlyLegal = dueMonthlyLegalContents;
    legalInfo.dueFirstMonthLegal = dueFirstMonthLegalContents;
    legalInfo.govTaxLegal = govTaxAndFees;
    return legalInfo;
}
exports.getLegalInfo = getLegalInfo;
function servicePeriodLabel(accountInfo, cartSummaryCMSData) {
    if (accountInfo && accountInfo.billCycleStartDate && accountInfo.billCycleEndDate) {
        var servicePeriodLabelTxt = cartSummaryCMSData.bsseServicePeriodLabel;
        var billCycleDay = void 0;
        if (accountInfo.billCycleDay) {
            billCycleDay = parseInt(accountInfo.billCycleDay, 10);
        }
        else {
            var billEndDay = parseInt(accountInfo.billCycleEndDate.split('/')[1], 10);
            billCycleDay = billEndDay > 28 ? 28 : billEndDay;
        }
        return servicePeriodLabelTxt.replace('{0}', accountInfo.billCycleStartDate)
            .replace('{1}', accountInfo.billCycleEndDate).replace('{2}', CartUtil.ordinalPostFix(billCycleDay));
    }
    else {
        return '';
    }
}
exports.servicePeriodLabel = servicePeriodLabel;
function includeTaxLabel(cart, cartSummaryCMSData) {
    if (cartSummaryCMSData.bsseIncludeTaxLabel && cart && cart.dueTodayOneTimeTaxes) {
        return cartSummaryCMSData.bsseIncludeTaxLabel.replace('{0}', "$" + amountWithDecimal(cart.dueTodayOneTimeTaxes, 2));
    }
    return '';
}
exports.includeTaxLabel = includeTaxLabel;
function getLegalData(legalObj) {
    var legalContent = {};
    if (legalObj && legalObj.legalModalPath) {
        CartUtil.getLegalIDPData(legalObj.legalModalPath, legalContent, legalObj.legallinkText, legalObj.shortText).then(function (legaldataobj) {
            legalContent = legaldataobj;
        });
    }
    return legalContent;
}
exports.getLegalData = getLegalData;
function displayPlanDetailsinModal(cartData) {
    var _a, _b;
    if (cartData.enablePlanModalFeature && ((_b = (_a = cartData === null || cartData === void 0 ? void 0 : cartData.wirelessCart) === null || _a === void 0 ? void 0 : _a.planModalDetails) === null || _b === void 0 ? void 0 : _b.planTotal) &&
        Number(cartData.wirelessCart.planModalDetails.planTotal) > 0) {
        return true;
    }
    return false;
}
exports.displayPlanDetailsinModal = displayPlanDetailsinModal;
function getDueTodayMonthlyLabel(payload, cartSummaryCMSData) {
    if (payload && payload.orderPriceInfo && payload.orderPriceInfo.prorated) {
        return cartSummaryCMSData.dueTodayPartialMonthlyLabel || 'Monthly charges (partial month)';
    }
    else {
        return cartSummaryCMSData.dueTodayMonthlyLabel;
    }
}
exports.getDueTodayMonthlyLabel = getDueTodayMonthlyLabel;
function displayLineItemPrice(lineItem, isEAPFlow) {
    var displayItemPrice = lineItem.price ? true : false;
    var getPromotionDetails = wlsUtils.getEffectivePromoPricing(lineItem);
    if ((getPromotionDetails && getPromotionDetails.isPromoLineItem) ||
        ((isEAPFlow) &&
            lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DEVICE')) {
        displayItemPrice = false;
    }
    return displayItemPrice;
}
exports.displayLineItemPrice = displayLineItemPrice;
function hideCapacityLink(isExpressUpgradeView, flagExpressUpCapacityLink) {
    return isExpressUpgradeView ? flagExpressUpCapacityLink : true;
}
exports.hideCapacityLink = hideCapacityLink;
function getSdpData(losgs, isMixAndMatch) {
    var sdpData = { count: 0, price: 0 };
    Object.keys(losgs).forEach(function (losgItemKey, index) {
        Object.keys(losgs[losgItemKey].lineItems).forEach(function (lineItemKey, secindex) {
            var lineItem = losgs[losgItemKey].lineItems[lineItemKey];
            var finalAmount = wlsUtils.getFinalPrice(lineItem.price, lineItem.itemType, isMixAndMatch);
            if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE') {
                sdpData = {
                    count: sdpData.count + 1,
                    price: parseFloat("" + sdpData.price) + parseFloat("" + finalAmount),
                };
            }
        });
    });
    return sdpData;
}
exports.getSdpData = getSdpData;
function getPlanInfo(losg) {
    var planInfo = { displayName: '', price: 0 };
    Object.keys(losg.lineItems).forEach(function (lineItemKey, secindex) {
        var _a;
        var lineItem = losg.lineItems[lineItemKey];
        if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE') {
            planInfo = {
                displayName: lineItem === null || lineItem === void 0 ? void 0 : lineItem.displayName,
                price: (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) === null || _a === void 0 ? void 0 : _a.amount,
            };
        }
    });
    return planInfo;
}
exports.getPlanInfo = getPlanInfo;
function getIXPValue(featureName) {
    var featureService = FeatureService_1.default.getInstance();
    return featureService.getFeatureStatus(featureName);
}
exports.getIXPValue = getIXPValue;
function getIXPFlagValue(featureName) {
    var featureService = FeatureService_1.default.getInstance();
    return featureService.getFeatureStatusValue(featureName);
}
exports.getIXPFlagValue = getIXPFlagValue;
function unauthenticatedAccess() {
    var payload = getCartResp();
    return !!(payload === null || payload === void 0 ? void 0 : payload.unauthAccess);
}
exports.unauthenticatedAccess = unauthenticatedAccess;
function isAppleDevice() {
    var _a;
    var isApple = false;
    var cartResp = getCartResp();
    if ((_a = cartResp === null || cartResp === void 0 ? void 0 : cartResp.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        var losgs = Object.values(cartResp.wirelessCart.losgs);
        if (losgs) {
            losgs.forEach(function (losg) {
                var items = Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
                if (items) {
                    items.forEach(function (item) {
                        var _a;
                        if (((_a = item === null || item === void 0 ? void 0 : item.hardGood) === null || _a === void 0 ? void 0 : _a.make) === 'Apple') {
                            isApple = true;
                        }
                    });
                }
            });
        }
    }
    return isApple;
}
exports.isAppleDevice = isAppleDevice;
exports.isBMWFlow = function () {
    var _a, _b;
    var payload = getCartResp();
    return !!(((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.orderSource) === 'BMW_SMART');
};
function isWearableEAPFlow() {
    var _a;
    var payload = getCartResp();
    var isWearableEAP = false;
    var losgs = Object.values((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs);
    if (losgs) {
        losgs === null || losgs === void 0 ? void 0 : losgs.forEach(function (losg) {
            var _a, _b, _c;
            var lineItem = wlsUtils === null || wlsUtils === void 0 ? void 0 : wlsUtils.getDeviceLineItem(losg);
            var eapDetails = CartUtil === null || CartUtil === void 0 ? void 0 : CartUtil.getEAPDetails();
            if ((((_c = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _a === void 0 ? void 0 : _a.wirelessHardGoodCharacteristics) === null || _b === void 0 ? void 0 : _b._deviceSubType) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'WEARABLE'
                && eapDetails.isEAPFlow && eapDetails.eapFlowType.toUpperCase() === 'AAL_EAP_ON')) {
                isWearableEAP = true;
            }
        });
    }
    return isWearableEAP;
}
exports.isWearableEAPFlow = isWearableEAPFlow;
function isMDPPInsuranceSelected(LosgsData) {
    // check is MDPP selected or not in any line
    var isMDPP = false;
    if (LosgsData) {
        LosgsData.forEach(function (losg) {
            if (losg === null || losg === void 0 ? void 0 : losg.lineItems) {
                Object.values(losg.lineItems).forEach(function (e) {
                    var _a, _b, _c;
                    if (((_a = e === null || e === void 0 ? void 0 : e.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'feature' && ((_b = e === null || e === void 0 ? void 0 : e.productSubType) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'insurance') {
                        if (((_c = e === null || e === void 0 ? void 0 : e._itemExtraAttributes) === null || _c === void 0 ? void 0 : _c.InsuranceType) === 'MDPP') {
                            isMDPP = true;
                        }
                    }
                });
            }
        });
    }
    return isMDPP;
}
exports.isMDPPInsuranceSelected = isMDPPInsuranceSelected;
//# sourceMappingURL=UtilityFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/utils/UtilityFunctions.js
// module id = 5
// module chunks = 8